import PopupManager from '../../utils/PopupManager.js';
import Utils from '../../utils/Utils.js';
import Config from '../../utils/Config.js';
import SwitchButton from '../SwitchButton.js';
import StateButton from '../StateButton.js';
import HelpPopup from '../../popups/HelpPopup';
import LocaleManager from '../../utils/LocaleManager.js';
import SoundManager from '../../utils/SoundManager.js';

export default class MenuPanel extends Phaser.Group {
    constructor(game, {
        availableStakes, stake,
        minAutoSpins, maxAutoSpins, autoSpins, autoSpinsStep
    } = {})
    {
        super(game);

        this.onAction = new Phaser.Signal();

        this._isOpen = false;
        let buttonToggle = this.buttonToggle = new StateButton(game, 8, 8, 'buttons.menu', this.buttonToggleClickHandler, this);
        this.addChild(buttonToggle);

        let bg = this.bg = new Phaser.Graphics(game, -301, 0);
        bg.inputEnabled = true;
        bg.beginFill(0x1A1A1A);
        bg.lineStyle(2, 0xFFFFFF);
        if (Config.START_ORIENTATION === Config.PORTRAIT)
        {
            bg.drawRect(0, 0, Config.GAME_WIDTH, 200);
        }
        else
        {
            bg.drawRect(0, 0, 300, Config.GAME_HEIGHT);
        }
        bg.endFill();
        this.addChild(bg);

        const localeFontSettings = {
            'de': {
                fontSize: 22
            },
            'es': {
                fontSize: 22
            },
            'no': {
                fontSize: 26
            },
            'sr': {
                fontSize: 26
            },
            'sv': {
                fontSize: 24
            },
        }[LocaleManager.locale] || {
            fontSize: 30
        };

        let title = new Phaser.Text(game, bg.width >> 1, 0, LocaleManager.getString('settings'), {
            fill:'#FFFFFF',
            font: Config.DEFAULT_FONT,
            fontSize: localeFontSettings.fontSize,
            fontWeight: 'bold'
        });
        title.anchor.x = 0.5;
        this.addChild(title);

        let separator = new Phaser.Graphics(game, -bg.width + 30, title.y + title.height + 10);
        separator.lineStyle(2, 0xFFFFFF);
        separator.lineTo(bg.width - 60, 0);
        this.addChild(separator);

        //ACTION BUTTONS
        const buttonHelp = this._help = new StateButton(game, -250, Config.GAME_HEIGHT - 80, 'buttons.help', () =>
        {
            SoundManager.playSound('sounds/touch');
            this.onAction.dispatch(this, 'help');
        });
        buttonHelp.hitArea = null;
        buttonHelp.anchor.set(0.5);
        this.addChild(buttonHelp);
        let label = new Phaser.Text(game, buttonHelp.x, buttonHelp.y + 35, LocaleManager.getString('help'), {
            fill: '#FFFFFF',
            font: Config.DEFAULT_FONT,
            fontSize: 14,
            fontWeight: 'bold'
        });
        label.anchor.x = 0.5;
        this.addChild(label);

        const homeButton = new StateButton(game, -60, buttonHelp.y, 'buttons.home', () =>
        {
            this.onAction.dispatch(this, 'home');
        });
        homeButton.hitArea = null;
        homeButton.anchor.set(0.5);
        homeButton.enabled = !!Config.LOBBY_URL;
        this.addChild(homeButton);

        let label2 = new Phaser.Text(game, homeButton.x, homeButton.y + 35, LocaleManager.getString('HOME'), {
            fill: '#FFFFFF',
            font: Config.DEFAULT_FONT,
            fontSize: 14,
            fontWeight: 'bold'
        });
        label2.anchor.x = 0.5;
        this.addChild(label2);

        let optionsGroup = new Phaser.Group(game);
        this.addChild(optionsGroup);

        let musicCheckbox = this._musicCheckBox = new SwitchButton(game, 0, 0, 'buttons.checkbox');
        musicCheckbox.checked = SoundManager.music;
        musicCheckbox.onSwitch.add((target, value) =>
        {
            this.onAction.dispatch(this, 'music', value);
        });
        optionsGroup.addChild(musicCheckbox);

        let musicLabel = new Phaser.Text(game, 0, musicCheckbox.y + (musicCheckbox.height >> 1) + 2, LocaleManager.getString('music'), {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        musicLabel.anchor.set(0, 0.5);
        optionsGroup.addChild(musicLabel);

        let soundsCheckbox = this._soundCheckBox = new SwitchButton(game, musicCheckbox.x, musicCheckbox.y + musicCheckbox.height + 10, 'buttons.checkbox');
        soundsCheckbox.checked = SoundManager.sound;
        soundsCheckbox.onSwitch.add((target, value) =>
        {
            this.onAction.dispatch(this, 'sound', value);
        });
        optionsGroup.addChild(soundsCheckbox);

        let soundLabel = new Phaser.Text(game, 0, soundsCheckbox.y + (soundsCheckbox.height >> 1) + 2, LocaleManager.getString('sound_effects'), {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        soundLabel.anchor.set(0, 0.5);
        optionsGroup.addChild(soundLabel);

        let maxLabelWidth = Math.max(musicLabel.width, soundLabel.width);
        musicCheckbox.x = soundsCheckbox.x = maxLabelWidth + 30 - musicCheckbox.getLocalBounds().x;

        switch (Config.layout)
        {
            case Config.PORTRAIT:
                bg.position.set(0, -bg.height - 1);
                title.position.set(bg.x + (bg.width >> 1), bg.y + 10);
                separator.position.set(30, title.y + title.height + 4);

                homeButton.position.set(this.bg.width - 60, separator.y + 55);
                label2.position.set(homeButton.x, homeButton.y + 40);
                buttonHelp.position.set(homeButton.x - 100, separator.y + 55);
                label.position.set(buttonHelp.x, buttonHelp.y + 40);
                optionsGroup.position.set(
                    separator.x,
                    separator.y + 26
                );
                break;

            default:
                title.position.set(bg.x + (bg.width >> 1), bg.y + 10);
                soundsCheckbox.x = musicCheckbox.x = bg.width - 30 - soundsCheckbox.width;
                optionsGroup.position.set(
                    bg.x + (bg.width - optionsGroup.width >> 1),
                    separator.y + 20
                );
        }

        this.game.input.onDown.add(this.onGameInputDown, this);

        let closeButton = new StateButton(game, 0, 0, 'popups.common.close', this.buttonToggleClickHandler, this);
        closeButton.x = bg.x + 8;
        closeButton.y = bg.y + 8;
        this.addChild(closeButton);
    }

    lock(canPause = false)
    {

    }

    unlock(canPause = false)
    {
        if (canPause)
        {
            return;
        }
    }

    onGameInputDown(event)
    {
        if (!Config.MobileDevice)
        {
            return;
        }

        if (this._isOpen && this.hitTestEvent(event) === false)
        {
            this.toggle(false);
        }
    }

    hitTestEvent(event)
    {
        let boundsEvent = new Phaser.Rectangle(event.x, event.y, 1,1);
        let boundsView = this.bg.getBounds();
        boundsView.x = 0;
        boundsView.y = 0;

        if (Config.START_ORIENTATION === Config.PORTRAIT)
        {
            boundsView.height += this.buttonToggle.y + this.buttonToggle.height;
        }
        else
        {
            boundsView.width += this.buttonToggle.x + this.buttonToggle.width;
        }
        return Phaser.Rectangle.intersects(boundsEvent, boundsView);
    }

    buttonToggleClickHandler()
    {
        this.toggle();
    }

    isOpen()
    {
        return this._isOpen;   
    }
    
    toggle(value)
    {
        if (value === undefined)
        {
            value = !this.isOpen();
        }
        else if (value === this.isOpen())
        {
            return;
        }

        value ? this.open() : this.close();

        SoundManager.playSound('sounds/touch');
        leanderGMApi.publishEvent(leanderGMApi.publications.CONTROL_PANEL_STATUS_CHANGED_GAME, value);
    }
    
    close()
    {
        const tween = this.game.add.tween(this);
        this._isOpen = false;

        if (Config.START_ORIENTATION === Config.PORTRAIT)
        {
            tween.to({ y: 0 }, 500, Phaser.Easing.Elastic.Out);
        }
        else
        {
            tween.to({ x: 0 }, 500, Phaser.Easing.Elastic.Out);
        }

        tween.start();  
    }

    open()
    {
        const tween = this.game.add.tween(this);
        this._isOpen = true;
        if (Config.START_ORIENTATION === Config.PORTRAIT)
        {
            tween.to({ y: this.bg.height }, 500, Phaser.Easing.Elastic.Out);
        }
        else
        {
            tween.to({ x: this.bg.width }, 500, Phaser.Easing.Elastic.Out);
        }
        tween.start(); 
    }

    destroy()
    {
        this.game.input.onDown.remove(this.onGameInputDown, this);
        super.destroy();
    }

    get enabled()
    {
        return !!this._enabled;
    }

    set enabled(value)
    {
        this._help.enabled = this._enabled = !!value;
    }
}